import { render, staticRenderFns } from "./PlayerOrTeamName.vue?vue&type=template&id=c618d17c&"
import script from "./PlayerOrTeamName.vue?vue&type=script&lang=js&"
export * from "./PlayerOrTeamName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports